const regions = [
  // 'United States',
  // 'Canada',
  // 'United Kingdom',
  // 'Ireland',
  // 'Australia',
  // 'New Zealand',
  // 'United Arab Emirates',
  // 'Kingdom Saudi Arabia',
  // 'Pakistan',
];

function RailList({ hidden = false }) {
  return (
    <ul className="region-rail-list" aria-hidden={hidden}>
      {regions.map((region) => (
        <li key={region}>
          <span>{region}</span>
          <small aria-hidden="true">-</small>
        </li>
      ))}
    </ul>
  );
}

function RegionRail() {
  return (
    <div className="region-rail">
      <div className="region-rail-track">
        <RailList />
        <RailList hidden />
      </div>
    </div>
  );
}

export default RegionRail;